<template lang="pug">
  .box
    .header
      h1
        img(src="../assets/img/logo.png" alt="")
      .nav
        ul
          li
            a(href="javascript:;" @click="goHome" :class="[this.$store.state.flag==1?'bdBlue':'']") 网站首页
          li
            a(href="javascript:;" @click="goProduct" :class="[this.$store.state.flag==2?'bdBlue':'']") 业务产品
          li
            a(href="javascript:;" @click="goSlution" :class="[this.$store.state.flag==4?'bdBlue':'']") 解决方案
          li
            a(href="javascript:;" @click="goCase" :class="[this.$store.state.flag==3?'bdBlue':'']") 成功案例
          li
            a(href="javascript:;" @click="goNews" :class="[this.$store.state.flag==5?'bdBlue':'']") 新闻资讯
          li
            a(href="javascript:;" @click="goContact" :class="[this.$store.state.flag==6?'bdBlue':'']") 客户服务
          li
            a(href="javascript:;" @click="goWe" :class="[this.$store.state.flag==7?'bdBlue':'']") 关于我们
    .banner
    .body
      h2 企业使命
      h3 让人人享受数智生活
      p 兰州速云软件科技有限公司致力于软件开发、数字信息化建设、为行业品牌企业提供智慧管理、数字经济体建立，全方位保障企业数智化基础设施服务，使目标客户更加信赖企业的产品及服务，从而提高企业的品牌价值。一直以来，公司以"让人人享受数智生活"为使命打造了一支集合了八十多名有着多年行业经验的技术服务团队，其中研发工程师37名，部署专家25名，运维工程师21名，完善的公司组织架构和强硬的员工技能素质，速云只为客户提供更加优质的鼓术支持与服务。公司目前已拥有自主研发的品牌"速云"，我们的产品速云平台"通过认证已成功上架钉钉应用市场;并已广泛应用于各类企业，实现个性化定制产品在今年的疫情期间为客户成功打造了"陇政钉协助线上政务办公和"平凉市疫情防控网格化管理服务平台等定制产品，均获得了一致好评！
      h4 欢迎各大企业前来洽谈合作！
      span 联系电话：4000931866
      span 邮箱：lzsyrjkj@163.com
      h5 兰州速云软件科技有限公司，期待与您相遇！
    .footer
      .footerLeft
        img(src="../assets/img/logobai.png" alt="")
        ul
          li
            //p 咨询电话：<span>0931-0000000</span>
          li
            //p 咨询电话：<span>0931-0000000</span>
          li
            p 咨询电话：<span>400-0931-866</span>
          li 隐私声明 | 版权所有 © 速云软件 2001-2020 备注号 陇ICP备18000095号-1
      .footerRight
        .barCode
          img(src="../assets/img/weibo.png" alt="")
          h5 官方微博
        .barCode
          img(src="../assets/img/gongzhong.jpg" alt="")
          h5 官方公众号
        .barCode
          img(src="../assets/img/toutiao.jpg" alt="")
          h5 官方头条
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    goWe () {
      window.scroll(0, 0)
      this.$router.push('/we')
    },
    goProduct () {
      window.scroll(0, 0)
      this.$router.push('/product')
    },
    goHome () {
      window.scroll(0, 0)
      this.$router.push('/home')
    },
    goNews () {
      window.scroll(0, 0)
      this.$router.push('/news')
    },
    goSlution () {
      window.scroll(0, 0)
      this.$router.push('/slution')
    },
    goContact () {
      window.scroll(0, 0)
      this.$router.push('/contact')
    },
    goCase () {
      console.log(1)
    }
  },
  mounted () {
    document.title = '伙伴招募'
  }
}
</script>

<style lang="less" scoped>
  .box{
    width: 100%;
    .header{
      width: 100%;
      height: 14vh;
      background-color: #fff;
      box-shadow: 1px 1px 4px rgba(0, 0, 0, .3);
      h1{
        float: left;
        margin: 4vh 0 0 8vw;
        img{
          width: 11vw;
        }
      }
      .nav{
        ul{
          float: left;
          margin: 4vh 0 0 20vw;
          li{
            float: left;
            padding: 0 20px;
            a{
              display: inline-block;
              height: 44px;
              line-height: 44px;
            }
            a:hover{
              border-bottom: 3px solid #409fee;
            }
          }
        }
      }
    }
    .banner{
      width: 100%;
      height: 386px;
      background-image: url(../assets/img/bannerZM.jpg);
      background-size: cover;
      background-position: 50%;
    }
    .body{
      width: 70%;
      margin: 0 auto;
      overflow: hidden;
      h2{
        font-size: 28px;
        text-align: center;
        margin: 30px 0 10px;
      }
      h3{
        font-size: 24px;
        text-align: center;
        margin-bottom: 20px;
      }
      p{
        text-align: justify;
        line-height: 26px;
        text-indent: 2em;
      }
      h4{
        font-size: 20px;
        margin: 10px 0;
        font-weight: 400;
      }
      span{
        display: block;
        font-size: 20px;
        margin-bottom: 10px;
      }
      h5{
        font-size: 20px;
        text-align: center;
        margin-bottom: 30px;
      }
    }
    .footer{
      width: 100%;
      height: 240px;
      background-color: #20242B;
      .footerLeft{
        float: left;
        margin-left: 12%;
        padding-top: 52px;
        img{
          width: 156px;
          height: 39px;
        }
        li{
          margin-top: 22px;
          font-size: 14px;
          color: #fff;
          p{
            font-size: 16px;
            span{
              color: #017CF8;
            }
          }
        }
      }
      .footerRight{
        float: right;
        margin-right: 12%;
        margin-top: 52px;
        .barCode{
          display: inline-block;
          width: 136px;
          height: 180px;
          background-color: #fff;
          margin-left: 42px;
          img{
            display: inline-block;
            width: 122px;
            height: 122px;
            margin: 7px;
            vertical-align: middle;
          }
          h5{
            width: 136px;
            height: 44px;
            font-weight: 400;
            background-color: #007BF9;
            line-height: 44px;
            text-align: center;
          }
        }
      }
    }
    .bc{
      background-color: #fff!important;
      color: #b08454!important;
    }
    .bdBlue{
      border-bottom: 3px solid #409fee;
    }
  }
</style>
